'use strict';

// Add init function that is executed on every page/fragment render
import { closeAction } from './tippy-util';

mpro.addInitStatic(async ($container) => {

	// Detect window size
	const mediaObjectDropdown = window.matchMedia('(min-width: 992px)');
	const handleMediaDropdownChange = (e) => {
		// Check if the media query is true
		// if (e.matches) {
			mediaObjectDropdown.removeEventListener('change', handleMediaDropdownChange);

			mpro.initTippyFacets($container);
			const facetsContainers = ['.facets-sidebar__menu', '.facets-page-top__menu'];
			facetsContainers.forEach((containerClass) => {
				mpro.initFilterSelect2($container.find(containerClass));
				mpro.handleFacetsSubmit($container.find(containerClass));
			});
		// }
	};
	// Register event listener
	mediaObjectDropdown.addEventListener('change', handleMediaDropdownChange);
	// Initial check
	handleMediaDropdownChange(mediaObjectDropdown);

	/******************************************************************************************************************/

	const $facetsMenu = $container.find('[data-facets-menu]');

	// Open facets in mmenu for mobile
	if ($facetsMenu.length > 0) {

		const $filterContainer = $facetsMenu.clone();
		const filterContainer = $filterContainer[0];
		const batch_selection = mpro.config.mobile.facets.batch_selection || ($filterContainer.find('.facet__batch-selection').length > 0);
		let filter;

		/**
		 * @param {any} Mmenu
		 */
		const initMobileFilter = (Mmenu) => {

			if (!filter) {

				// Wrap page content
				if ($('#mmenu_offcanvas').length === 0) {
					$('body > *').wrapAll('<div id="mmenu_offcanvas"></div>');
				}

				$filterContainer.find('.facet--exclude-mobile').remove();
				$filterContainer.find('.collapse').removeClass('collapse').removeClass('show');

				// Transform hidden inputs into checkboxes
				$filterContainer.find('.facet__options--tag').find('.facet__option--tag').find('input[type=hidden]').each(function() {
					const $this = $(this);
					$this.attr('type', 'checkbox').val($this.data('value'));
					if (typeof ($this.data('checked')) !== 'undefined') {
						$this.attr('checked', 'checked');
					}
				})
					.end().addClass('facet__option--checkbox').removeClass('facet__option--tag')
					.end().addClass('facet__options--checkbox').removeClass('facet__options--tag')
					.parent().addClass('facet__content--checkbox').removeClass('facet__content--tag');

				// Transform selects into radios
				$filterContainer.find('.facet__content--select').find('select').each(function() {
					const $select = $(this);
					$select.unwrap('.facet__options--select');
					let selectReplacement = '<ul class="facet__options facet__options--radio">';
					$select.find('option').each(function() {
						const $option = $(this);

						selectReplacement += '<li class="facet__option facet__option--radio">' +
							'<input type="radio" name="' + $select.attr('name') + '" value="' + $option.attr('value') + '" ' + ($option.prop('selected') ? 'checked' : '') + '>' +
							($option.data('color') ? '<em class="facet__option-color" style="background: ' + $option.data('color') + ';"></em>' : ($option.data('image') ? '<em class="facet__option-image" style="background-image: url(\'' + $option.data('image') + '\'); background-size: contain; background-repeat: no-repeat; background-position: center center;"></em>' : '')) +
							'<a href="' + $option.data('url') + '" ' + ($option.data('count') ? ('data-count="' + $option.data('count') + '"') : '') + '>' + $option.text() + '</a>' +
							'</li>';
					});
					selectReplacement += '</ul>';

					$select.replaceWith(selectReplacement);
				}).end().removeClass('facet__content--select').removeClass('facet__content--radio');

				// Save original facet title (without counters and selected values)
				$filterContainer.find('.facet').each(function() {
					const $this = $(this);
					const $titleClone = $this.find('.facet__title').clone();

					$titleClone.find('.facet__title-selected-cnt').remove();
					$titleClone.find('.facet__title-selected-values').remove();

					$this.find('.facet__options').attr('data-title', $.trim($titleClone.text()));
				});

				let footerNavbar = [];
				if (batch_selection) {
					footerNavbar = [
						{
							'position': mpro.config.mobile.facets.filter_button_position ?? 'bottom',
							'content': [
								'<button class="btn btn-primary facet__batch-selection">' + filterContainer.dataset.title + '</button>',
							]
						}
					];
				}

				let topNavbar = [
					'prev',
					'title',
					'<span class="mm-navbar__clear" data-clear-all><a href="' + filterContainer.dataset.clearUrl + '">' + filterContainer.dataset.clearText + '</a></span>',
				];
				if (batch_selection) {
					topNavbar.push('<span class="mm-navbar__clear" style="display: none;" data-clear-filter><a href="javascript:void(0);">' + filterContainer.dataset.deleteText + '</a></span>');
				}

				// Init mobile menu plugin
				filter = new Mmenu(filterContainer, {
					slidingSubmenus: !mpro.config.mobile.facets.expandable,
					counters: {
						add: false,
					},
					theme: 'white',
					hooks: {
						'open:before': function() {
							// Add additional close icon on the blocker
							$('.mm-wrapper__blocker').addClass('mm-btn--close').html('<svg class="mm-menu_close" data-menu-close viewBox="0 0 512 512" id="icon-icon-x" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M471.8 464.5 277.1 269.9c-9-9-9.2-18.6 0-27.7L471.8 47.5s11.9-11.5.7-22.4c-10.6-10.3-22.2 1.4-22.2 1.4L255.9 220.9c-1.9 1.9-3.7 3.8-5.4 5.6-1.7-1.8-3.5-3.7-5.4-5.6L50.7 26.6s-11.6-11.7-22.2-1.4c-11.2 10.8.7 22.3.7 22.3l194.6 194.6c9.2 9.2 9 18.7 0 27.7L29.2 464.5s-11.9 11.5-.7 22.4c10.6 10.3 22.2-1.4 22.2-1.4l194.4-194.4c1.9-1.9 3.7-3.8 5.4-5.6 1.7 1.8 3.5 3.7 5.4 5.6l194.4 194.4s11.6 11.7 22.2 1.4c11.2-10.9-.7-22.4-.7-22.4z"/></svg>');

							// Toggle header
							$('#mmenu_offcanvas').off('transitionend.toggle-header');
							$('#mmenu_offcanvas').addClass('mm-page').addClass('mm-slideout');
							$(this.node.menu).css({ 'display': 'flex' });
							$(this.node.wrpr)
								.removeClass('mm-wrapper--position-left')
								.removeClass('mm-wrapper--position-right')
								.addClass('mm-wrapper--position-' + this.opts.offCanvas.position);
							const viewport = document.querySelector('meta[name=viewport]');
							viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');

							const windowScroll = window.scrollY;
							const wrapper = document.querySelector('.mm-wrapper');
							wrapper.style.position = 'fixed';
							wrapper.style.top = `-${windowScroll}px`;
							wrapper.style.width = '100%';
						},
						'close:after': function() {
							const self = this;
							// Toggle header
							$('#mmenu_offcanvas').one('transitionend.toggle-header', function(e){
								$('#mmenu_offcanvas').removeClass('mm-page').removeClass('mm-slideout');
								$(self.node.menu).css({ 'display': 'none' });
								$(self.node.wrpr).removeClass('mm-wrapper--position-' + self.opts.offCanvas.position);
								const viewport = document.querySelector('meta[name=viewport]');
								viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=5');

								const wrapper = document.querySelector('.mm-wrapper');
								const scrollY = wrapper.style.top;
								wrapper.style.position = '';
								wrapper.style.top = '';
								wrapper.style.width = '';
								document.documentElement.style.scrollBehavior = 'auto';
								window.scrollTo(0, parseInt(scrollY || '0') * -1);
								document.documentElement.style.scrollBehavior = 'smooth';
							});
						},
						'openPanel:before': function(panel) {
							const $panel = $(panel);
							const $menu = $(this.node.menu);

							if ($panel.is('.facet__content')) {
								// Set the original title
								if (!mpro.config.mobile.facets.expandable) {
									$panel.find('.mm-navbar__title span').text($panel.find('.facet__options').data('title'));
									$menu.find('.mm-navbars--top .mm-navbar__title span').text($panel.find('.facet__options').data('title'));
								}

								if (batch_selection) {
									// Toggle clear buttons
									$menu.find('.mm-navbars--top [data-clear-all]').hide();
									if ($panel.is('.facet__content--checkbox') || $panel.is('.facet__content--text') || $panel.is('.facet__content--range-input')) {
										$menu.find('.mm-navbars--top [data-clear-filter]').show();
									}
								}
							}
							else {
								$menu.find('.mm-navbars--top [data-clear-filter]').hide().end().find('.mm-navbars--top [data-clear-all]').show();
							}
						},
						'openPanel:after': function(panel) {

							const $panel = $(panel);
							const $facetOptions = $panel.find('.facet__options');
							$panel.addClass('mm-panel--opened');

							if ($facetOptions) {

								if (batch_selection) {
									$facetOptions.addClass('facet__options--batch-selection');
								}
								else {
									$facetOptions.removeClass('facet__options--batch-selection');
								}
								$panel.find('.facet__batch-selection').remove();

								$facetOptions.removeClass('facet__options--color');
								$facetOptions.removeClass('facet__options--image');
								$facetOptions.find('input:checkbox').addClass('mm-check');
								$facetOptions.find('input:radio').addClass('mm-toggle');
								$facetOptions.find('.facet__option-color').addClass('mm-listitem__btn');
								$facetOptions.find('.facet__option-image').addClass('mm-listitem__btn');
								$facetOptions.find('.facet__option').each(function() {
									const $this = $(this);
									$this.find('em').each(function() {
										$this.find('.mm-check').add($this.find('.mm-toggle')).addClass('mm-color').prop('style', $(this).attr('style'));
										$(this).remove();
									});

									$this.find('em').detach().insertBefore($this.find('a'));
								});
								$facetOptions.find('a[data-count]').each(function() {
									const $this = $(this);
									if (!$this.find('.mm-counter').length) {
										$this.append('<span class="mm-counter">' + $this.data('count') + '</span>');
									}
								});
								$facetOptions.find('.facet__option[data-count]').each(function() {
									const $this = $(this);
									if (!$this.find('.mm-counter').length) {
										$this.find('a').append('<span class="mm-counter">' + $this.data('count') + '</span>');
									}
								});
							}
						},
						'closePanel:after': function(panel) {
							const $panel = $(panel);
							$panel.removeClass('mm-panel--opened');
						},
					},
					offCanvas: {
						position: mpro.config.mobile.facets.offcanvas_position || 'right',
					},
					backButton: {
						close: true,
					},
					navbar: {
						'add': false,
						'title': filterContainer.dataset.title,
					},
					navbars: [
						{
							'position': 'top',
							'content': topNavbar,
						},
						...footerNavbar,
					],
				}, {
					offCanvas: {
						clone: true,
						page: {
							selector: '#mmenu_offcanvas',
						}
					},
				});

				// Get the API
				const api = filter.API;

				// Open range filters
				if (mpro.config.mobile.facets.expandable) {
					$(filter.node.pnls).find('.facet__options--range-slider').each(function() {
						api.openPanel(this);
					});
				}

				// Reinit sliders
				$(filter.node.pnls).find('.filter-slider').each(function() {
					mpro.initFilterSlider(this);
				});

				$(filter.node.menu).on('click', '.mm-navbars--top [data-clear-filter]', function() {
					if (mpro.config.mobile.facets.expandable) {
						$(filter.node.menu).find('.mm-listitem--opened .mm-panel').each(function() {
							$(this).find('input:checkbox').prop('checked', false).last().trigger('summary');
							$(this).find('input:text').val('').last().trigger('summary');
						});
					}
					else {
						$(filter.node.menu).find('.mm-panel--opened input:checkbox').prop('checked', false).last().trigger('summary');
						$(filter.node.menu).find('.mm-panel--opened input:text').val('').last().trigger('summary');
					}
					// $(this).hide();
				});

				// Handle filter submission
				mpro.handleFacetsSubmit(filter.node.menu);
			}
		};

		/******************************************************************************************************************/

		// // Detect window size
		// const mediaObjectMobileFilters = window.matchMedia('(max-width: 992px)');
		// const handleMediaMobileFiltersChange = async (e) => {
			// Check if the media query is true
			// if (e.matches) {

				const $filterToggle = $container.find('[data-filter-toggle]');

				if ($filterToggle.length > 0 && $filterToggle.is(':visible')) {
					// mediaObjectMobileFilters.removeEventListener('change', handleMediaMobileFiltersChange);

					// Import mmenu-js lib
					// @ts-ignore
					const { default: Mmenu } = await import('mmenu-js');

					$filterToggle.one('click', async (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();

						initMobileFilter(Mmenu);

						filter.API.open();
					}).on('click', (e) => {
						e.preventDefault();

						filter.API.open();
					});
				}
			// }
		// };
		// // Register event listener
		// mediaObjectMobileFilters.addEventListener('change', handleMediaMobileFiltersChange);
		// // Initial check
		// await handleMediaMobileFiltersChange(mediaObjectMobileFilters);
	}
});
